import { render } from "./ErrorComponent.vue?vue&type=template&id=31d52730&ts=true"
import script from "./ErrorComponent.vue?vue&type=script&lang=ts"
export * from "./ErrorComponent.vue?vue&type=script&lang=ts"

import "./ErrorComponent.vue?vue&type=style&index=0&id=31d52730&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__